import React from "react";
import { Box, Typography } from "@mui/material";
import { Work } from "../../../types/work";
import VersionTable from "../../../components/tables/VersionsTable";

interface VersionsSectionProps {
  work: Work;
}

const VersionsSection: React.FC<VersionsSectionProps> = ({ work }) => {
  return (
    <Box sx={{ width: "100%", mb: 4 }}>
      <Typography variant="h2" gutterBottom>
        Versions
      </Typography>
      <VersionTable
        enableRowActions={false}
        // Every row belongs to this work; the column would repeat it.
        hiddenColumnIds={["work"]}
        filters={{
          system_language_type: work.system_language_type,
          work_id: work._key,
        }}
      />
    </Box>
  );
};

export default VersionsSection;
